// extracted by mini-css-extract-plugin
module.exports = {"Button":"v_rH r_rH r_rt g_fl g_fz g_fp g_g9","full":"v_sk g_dl g_dw","width100":"v_dl g_dl","design3Pos":"v_sl g_dQ"};